<template>
    <div class="small-button" :class="config.type" @click.stop="config.action()">
        <div v-if="config.stop" class="stop" @click.stop="config.stop()"><i class="fas fa-times-octagon"></i></div>
        <div class="instructions">
            <i class="icon" :class="config.icon"></i>
            <h4 v-html="config.title"></h4>
            <div v-html="config.subTitle"></div>
        </div>
        <div class="label">
            <span class="type"><i class="fas" :class="{
                    'fa-volume-up': config.type==='sound',
                    'fa-puzzle-piece': config.type==='puzzle',
                    'fa-play': config.type==='event',
                    'fa-tv': config.type==='screen'
                }"></i> {{config.type | capitalize}}</span>
            <span class="repeat" v-if="config.repeat"><i class="fas" :class="{'fa-stop-circle': config.repeat==='once', 'fa-repeat-alt': config.repeat==='repeat'}"></i> {{config.repeat | capitalize}}</span>
            <div class="clearfix"></div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['config'],
        data() {
            return {}
        },
        filters: {
            capitalize: function (value) {
                if (!value) return '';
                value = value.toString();
                return value.charAt(0).toUpperCase() + value.slice(1);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .small-button {
        position: relative;

        font-family: "Roboto", sans-serif;
        margin: 15px 0 10px 20px;

        text-align: center;
        min-height: 233px;
        width: 20%;
        min-width: 200px;

        background: rgba(0,0,0,0.7);
        display: inline-block;
        border: 1px solid rgba(255,255,255,0.3);
        cursor: pointer;

        float: left;

        i.icon {
            font-size: 35px;
        }

        h4 {
            margin: 20px 0;
            font-size: 20px;
        }

        .stop {
            position: absolute;
            top: 0;
            right: 0;
            padding: 4px 8px 3px 9px;
        }

        .instructions {
            padding: 30px 15px 20px;

            >div {
                font-size: 12px;
                color: rgba(255,255,255,0.5);
            }
        }

        .label {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;

            text-align: left;
            font-size: 11px;
            span {
                i {
                    margin-right: 3px;
                    font-size: 10px;
                }
                background-color: #333333;
                padding: 3px 6px 0 6px;

                &.type {
                    float: left;
                }
                &.repeat {
                    float: right;
                }
            }
        }

        &.event {
            border-color: #017AFF;
            background: rgba(1, 122, 255, 0.15);

            .label span, .stop {
                background-color: #017AFF;
            }
        }
        &.puzzle {
            border-color: #8800c4;
            background: rgba(136, 0, 196, 0.15);

            .label span, .stop {
                background-color: #8800c4;
            }
        }
        &.sound {
            border-color: rgb(7, 121, 4);
            background: rgba(7, 121, 4, 0.15);

            .label span, .stop {
                background-color: rgb(7, 121, 4);
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/app/director/button.vue